import * as actionTypes from './action-types';
import {
  selectCachedTileJSONURL,
  selectDynamicTileJSONURL,
  selectTileJSONCacheUpdaterURL,
} from './selectors';

const { fetch } = window;

export const updateDimensions = ({ width, height }) => ({
  type: actionTypes.UPDATE_DIMENSIONS,
  payload: { width, height },
});

export const updateViewport = ({ bounds, zoom }) => ({
  type: actionTypes.UPDATE_VIEWPORT,
  payload: { bounds, zoom },
});

export const updateAPIProps = props => ({
  type: actionTypes.UPDATE_API_PROPS,
  payload: props,
});

const fetchJSON = async (url) => {
  if (url) {
    try {
      const response = await fetch(url);
      const json = await response.json();

      return json;
    } catch (err) {
      // fallthrough
    }
  }

  return null;
};

const updateTileJSONAction = tileJSON => ({
  type: actionTypes.UPDATE_TILE_JSON,
  payload: tileJSON || null,
});

export const updateTileJSON = () => async (dispatch, getState) => {
  const state = getState();

  await dispatch(updateTileJSONAction(null));

  const [cacheURL, dynamicURL, updateURL] = [
    selectCachedTileJSONURL(state),
    selectDynamicTileJSONURL(state),
    selectTileJSONCacheUpdaterURL(state),
  ];

  const urlHasNotChanged = () => cacheURL === selectCachedTileJSONURL(getState());

  let tileJSON = cacheURL && await fetchJSON(cacheURL);

  if (!tileJSON && urlHasNotChanged()) {
    tileJSON = dynamicURL && await fetchJSON(dynamicURL);
  }

  if (urlHasNotChanged()) {
    await dispatch(updateTileJSONAction(tileJSON));
  }

  const updatedTileJSON = updateURL && await fetchJSON(updateURL);

  if (updatedTileJSON && urlHasNotChanged()) {
    await dispatch(updateTileJSONAction(updatedTileJSON));
  }
};



// WEBPACK FOOTER //
// ./src/modules/map/actions.js